import { DateDisplay, ProfileDisplay } from "../../../components";
import { FixedCell } from "../../../components/tables/StandardTable";
import { TableLoadingRow } from "../../../components/tables/VirtualTable";
import { ThemedSpan } from "../../../components/utilities";
import { toCurrency } from "../../../helpers/numbers";

const NewBusinessRegisterTableRow = ({ data, index, style }) => {
    const { height } = style;

    if (data[index] == null)
        return <TableLoadingRow style={{ height }} />

    const {
        applicationReferenceId,
        masterAccountReference,
        masterAccountId,
        masterAccountName,
        adviserId,
        adviser,
        applicationDate,
        provider,
        description,
        investmentAmount,
        feeAmount,
        vatAmount,
        netFeeAmount,
        projectId,
        project,
        adviceTypeDescription,
        report,
        executionOnly
    } = data[index];

    return <tr style={{ height }} className="align-middle">
        <FixedCell className="text-truncate">
            {applicationReferenceId}
        </FixedCell>
        <FixedCell className="text-truncate">
            {masterAccountId != null && <a href={`/client/${masterAccountId}`}>{masterAccountReference} {masterAccountName}</a>}
        </FixedCell>
        <FixedCell className="text-truncate">
            <ProfileDisplay
                userId={adviserId}
                userDisplayName={adviser}
            />
        </FixedCell>
        <FixedCell className="text-truncate">
            <DateDisplay>{applicationDate}</DateDisplay>
        </FixedCell>
        <FixedCell className="text-truncate">
            {provider}
        </FixedCell>
        <FixedCell className="text-truncate">
            {description}
        </FixedCell>
        <FixedCell className="text-truncate text-end">
            {toCurrency(investmentAmount, 0)}
        </FixedCell>
        <FixedCell className="text-truncate text-end">
            {toCurrency(feeAmount, 2)}
        </FixedCell>
        <FixedCell className="text-truncate text-end">
            {toCurrency(vatAmount, 2)}
        </FixedCell>
        <FixedCell className="text-truncate text-end">
            {toCurrency(netFeeAmount, 2)}
        </FixedCell>
        <FixedCell className="text-truncate">
            {projectId != null && <p className="m-0 lh-1 text-truncate">
                {project}
                <br />
                <ThemedSpan variant="muted" className="fs-smallest">{adviceTypeDescription}</ThemedSpan>
            </p>}
        </FixedCell>
        <FixedCell className="text-truncate">
            {/* {report} */}
            <p className="m-0 lh-1 text-truncate">
                {report}
                <br />
                <ThemedSpan variant="muted" className="fs-smallest">{executionOnly && "Execution Only"}</ThemedSpan>
            </p>
        </FixedCell>
    </tr>
}

export default NewBusinessRegisterTableRow;